import { Products } from './products';
import { computeRecommendedProduct } from './recommendation';

export enum Questions {
  Problems = 'problems',
  Rooms = 'rooms',
}
export enum Problems {
  AirQuality = 'airQuality',
  Allergies = 'allergies',
  Asthma = 'asthma',
  Radon = 'radon',
}
export enum Rooms {
  Basement = 'basement',
  Bedroom = 'bedroom',
  Kitchen = 'kitchen',
  LivingRoom = 'livingRoom',
  Other = 'other',
}

export type Options = Problems | Rooms;

export type Question = {
  id: Questions;
  options: ReadonlyArray<QuestionOption>;
  required: boolean;
  translationKey: string;
};

type QuestionOption = {
  id: Options;
  translationKey: string;
};

const QUESTIONS: ReadonlyArray<Question> = [
  {
    id: Questions.Problems,
    translationKey: 'Problems',
    required: false,
    options: [
      { id: Problems.Radon, translationKey: 'Radon' },
      { id: Problems.Asthma, translationKey: 'Asthma' },
      { id: Problems.AirQuality, translationKey: 'AirQuality' },
      { id: Problems.Allergies, translationKey: 'Allergies' },
    ] as const,
  },
  {
    id: Questions.Rooms,
    translationKey: 'Rooms',
    required: true,
    options: [
      { id: Rooms.Basement, translationKey: 'Basement' },
      { id: Rooms.LivingRoom, translationKey: 'LivingRoom' },
      { id: Rooms.Bedroom, translationKey: 'Bedroom' },
      { id: Rooms.Kitchen, translationKey: 'Kitchen' },
      { id: Rooms.Other, translationKey: 'Other' },
    ] as const,
  },
] as const;

export const getQuestions = (): ReadonlyArray<Question> => QUESTIONS;

export const getRecommendedProduct = (formData: FormData): Products => {
  const problems = formData.getAll(Questions.Problems) as Problems[];
  const rooms = formData.getAll(Questions.Rooms) as Rooms[];

  return computeRecommendedProduct(problems, rooms);
};
